import { Dialog } from '@busybusy/webapp-react-ui';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import IPosition from 'types/Position';
import JsaReportsForm from '../forms/JsaReportsForm';

export interface IJsaReportsDetailProps {
  position: IPosition;
  editable: boolean;
  onUpdate: () => Promise<any>;
}

const JsaReportsDetail = ({ position, editable, onUpdate }: IJsaReportsDetailProps) => {
  const detailOpenable = useOpenable();

  const onSubmitForm = () => {
    detailOpenable.close();
    onUpdate();
  };

  return (
    <>
      <ProDetailsItem
        title={t('JSA Reports')}
        onClick={detailOpenable.open}
        value={
          position.createSafetyAnalysisReports
            ? position.manageSafetyAnalysisReports
              ? t('Manage')
              : t('Create Only')
            : t('Off')
        }
        hint={t('Allow the user to create JSA reports. They can also edit and delete their own reports.')}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={detailOpenable.isOpen} onClose={detailOpenable.close}>
        <JsaReportsForm
          onSubmit={onSubmitForm}
          createSafetyAnalysisReports={position.createSafetyAnalysisReports ?? false}
          manageSafetyAnalysisReports={position.manageSafetyAnalysisReports ?? false}
          positionId={position.id}
        />
      </Dialog>
    </>
  );
};

export default JsaReportsDetail;
